import { Component } from 'react';
import { inject, observer } from 'mobx-react';

//components
import withLocalization from '~/hoc/withLocalization';
import TableWidget from '../TableWidget.js';

class UserGroups extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user_groups: [],
        }
        this.loadData = this.loadData.bind(this);
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { currentEntity } = this.props.clientStore;
        if (currentEntity.client.data && currentEntity.client.data.extendedRules) {
            const extendedRules = Object.assign({}, currentEntity.client.data.extendedRules);
            this.setState({
                user_groups: extendedRules.user_groups
            })
        }
    }

    validateGroupUsageBeforeDelete = async (code) => {
        const { t } = this.props;
        try {
            const { extraPayments } = this.props.commonStore.config.client.data;
            for (let i = 0; i < extraPayments.length; i++) {
                let extraPayment = extraPayments[i];
                if (extraPayment.isActive && extraPayment.userGroups.split(',').indexOf(`${code}`) > -1)
                    return { isValid: false, message: t("Can't remove group as it's assigned to active extra payment") }
            }
            await this.props.clientStore.checkIfGroupInUse(code);
            return { isValid: true };
        }
        catch (err) {
            console.error({ err })
            return { isValid: false, message: t("Can't remove group as it's assigned to an employee") };
        }
    }

    handleDataChange = (data) => {
        const currentUserFullName = `${this.props?.userStore?.currentUser?.first_name} ${this.props?.userStore?.currentUser?.last_name}`;
        if (data.length) {
            data.forEach(group => {
                if (!group.created_by)
                    group.created_by = currentUserFullName;
                if (!group.assigned_pm)
                    group.assigned_pm = null;
            })
        }
        this.props.handleUserDataChange('user_groups', data);
    }


    render() {
        const { user_groups } = this.state;
        return (
            <div>
                <TableWidget
                    headers={['Code', 'Group name']}
                    metaData={[{ field: 'code', type: 'number', placeholder: '', required: true, unique: true, disabled: true },
                    { field: 'name', type: 'text', placeholder: 'Group name', required: true, unique: true }]}
                    data={user_groups}
                    onChange={this.handleDataChange}
                    deleteValidator={async (code) => this.validateGroupUsageBeforeDelete(code)}
                    className='mb-100'
                />
            </div >
        );
    }
}
export default inject('clientStore', 'commonStore', 'userStore')(withLocalization(observer(UserGroups)));
